import { gql } from "lib/apolloClient";

export const getGradingPeriodsQuery = gql`
  query getGradingPeriods(
    $id: ID!
    $curriculumIds: [ID!]
    $gradingPeriodsFilters: TermFilters!
  ) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        curriculumPrograms(curriculumIds: $curriculumIds) {
          gradingPeriods(filters: $gradingPeriodsFilters) {
            edges {
              node {
                id
                label
                startDate
                endDate
              }
            }
          }
        }
      }
    }
  }
`;

export const getUserCoursesV2CountQuery = gql`
  query getUserCoursesV2Count($userId: ID!, $courseFilters: CourseFilter) {
    node(id: $userId, type: STAFF) {
      id
      ... on Staff {
        coursesV2(filters: $courseFilters) {
          totalCount
          userMappedCount
          archivedCount
        }
      }
    }
  }
`;

export const getOrganizationSubjectGroupsQuery = gql`
  query getOrganizationSubjectGroups(
    $id: ID!
    $filters: SubjectGroupFilterInput
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjectGroups(filters: $filters) {
          id
          name
        }
      }
    }
  }
`;

export const getOrganizationSubjectsQuery = gql`
  query getOrganizationSubjects($id: ID!, $subjectFilters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjects(filters: $subjectFilters) {
          id
          name
        }
      }
    }
  }
`;
